<template>
  <div class="popup">
    <div class="popup-content">
      <div class="content">
        <p style="margin: 10px 0 40px 0;">{{ message }}</p>
      </div>
      
      <div class="buttons">
        <button class="btn decline">取消</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';

import { defineProps } from 'vue';
 
const props = defineProps({
  message: String
});
const acceptAnimation = ref('running');

function pauseAnimation(button) {
  if (button === 'accept') {
    acceptAnimation.value = 'paused';
  }
}

function resumeAnimation(button) {
  if (button === 'accept') {
    acceptAnimation.value = 'running';
  }
}
</script>
<style scoped>
.popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.content{
  margin: 20px;
}

.buttons {
  display: flex;
  justify-content: space-around;
  margin: 20px 40px;
}

.btn {
  width: 50px;
  height: 50px;
  padding: 5px;
  font-size: 16px;
  margin: 0 20px;
  border: none;
  cursor: pointer;
  border-radius: 50%;
}

.accept {
  background-color: #4caf50;
  color: white;
  animation: lively-bounce 2s infinite ease-in-out;
  animation-play-state: v-bind(acceptAnimation);
}

.decline {
  background-color: #f44336;
  color: white;
}

@keyframes lively-bounce {
  0% {
    transform: translateY(0) rotate(0deg) scale(1);
  }
  25% {
    transform: translateY(-20px) rotate(-5deg) scale(1.1);
  }
  50% {
    transform: translateY(0) rotate(0deg) scale(1);
  }
  75% {
    transform: translateY(-15px) rotate(5deg) scale(1.05);
  }
  100% {
    transform: translateY(0) rotate(0deg) scale(1);
  }
}
</style>
